const DOWNLOADABLE_EXTENSIONS = new Set([
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "xlsm",
  "ppt",
  "pptx",
  "zip",
  "rar",
  "7z",
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "svg",
  "ai",
  "eps",
  "psd",
  "tif",
  "tiff",
  "bmp",
  "csv",
  "txt",
  "rtf",
  "mp4",
  "mov",
  "avi",
  "wmv",
  "webm",
  "indd",
  "idml",
]);

const DOWNLOADABLE_CACHE_LIMIT = 1000;
const downloadableUrlCache = new Map<string, boolean>();

const urlHasFileExtension = (url: string): boolean => {
  try {
    const { pathname } = new URL(url);
    const segment = pathname.split("/").filter(Boolean).pop() ?? "";
    const dot = segment.lastIndexOf(".");
    if (dot <= 0 || dot === segment.length - 1) {
      return false;
    }
    return DOWNLOADABLE_EXTENSIONS.has(segment.slice(dot + 1).toLowerCase());
  } catch {
    return false;
  }
};

export const isDownloadableDocumentUrl = (url: string): boolean => {
  const cached = downloadableUrlCache.get(url);
  if (cached !== undefined) {
    return cached;
  }
  const result = urlHasFileExtension(url);
  if (downloadableUrlCache.size >= DOWNLOADABLE_CACHE_LIMIT) {
    const oldest = downloadableUrlCache.keys().next().value;
    if (oldest !== undefined) {
      downloadableUrlCache.delete(oldest);
    }
  }
  downloadableUrlCache.set(url, result);
  return result;
};
